exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-size[data-v-37f364db]{font-size:32px}@media (max-width: 768px){.icon-size[data-v-37f364db]{font-size:26px}}.whishlist-count[data-v-37f364db]{top:-3px;left:70%;background:#ff8100;min-width:16px;min-height:16px;border-radius:10px}@media (max-width: 768px){.whishlist-count[data-v-37f364db]{top:10px;left:55%}}\n", ""]);

// exports
